import type { SelectChangeEvent } from "@mui/material";
import { Grid, Select, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled.tsx";
import type { StatementAxisState } from "../../../../store/types/fieldsState.types.ts";
import { getAllowedOffsets } from "../utils/statementColumns.ts";

interface Props {
  dateOffsetMonths: number | undefined;
  axes: StatementAxisState[];
  readonly: boolean;
  onChange: (dateOffsetMonths: number | undefined) => void;
}

const OffsetSelect = ({ dateOffsetMonths, axes, readonly, onChange }: Props) => {
  const options = getAllowedOffsets(axes);

  const handleChange = (event: SelectChangeEvent<number>) => {
    const months = Number(event.target.value);
    onChange(months === 0 ? undefined : months);
  };

  return (
    <Grid container sx={{ alignItems: "center", width: "100%", px: 1.5, py: 0.75 }}>
      <Typography variant="caption">Offset</Typography>
      <HorizontalFill />
      <Select<number>
        value={dateOffsetMonths ?? 0}
        onChange={handleChange}
        disabled={readonly}
        sx={{ width: 160, ".MuiSelect-select": { py: 0.5, alignContent: "center" } }}
      >
        {options.map((option) => (
          <MenuItemStyled key={option.months} value={option.months}>
            <Typography variant="caption">{option.label}</Typography>
          </MenuItemStyled>
        ))}
      </Select>
    </Grid>
  );
};

export default OffsetSelect;
